import "bootstrap/dist/css/bootstrap.min.css";
import { TermsAndCondition } from "../../../Model/Setting/TermsAndCondition";
import AddUpdateForm from "../../../Components/AddUpdateForm";
import { Breadcrumb, Button } from "react-bootstrap";
import FieldDescription from "../../../Components/FieldDescription";
import { useEffect, useState } from "react";
import { DynamicFormFields } from "../../../Util/DynamicFormFields";
import { useParams } from "react-router-dom";
interface AddUpdateProps {
  title?: any;
  listRoute?: any;
  isNotUpdate?: any;
  onChangeModalStatus?: (status: boolean) => void;
}

const AddUpdate: React.FC<AddUpdateProps> = ({
  title,
  listRoute,
  isNotUpdate,
  onChangeModalStatus,
}) => {
  const { id } = useParams();
  const formFields = [
    {
      id: "inputName",
      label: "Name*",
      type: "text",
      col: 6,
      name: "name",
      placeholder: "Enter Name",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Name is required",
        },
      ],
      description:
        "Enter a distinctive and recognizable name for the specific set of terms and conditions. (Example: 'User Agreement', 'Service Terms', 'Product Usage Policies' etc.)",
    },
    {
      id: "inputDescription",
      label: "Description*",
      type: "text",
      col: 6,
      name: "description",
      placeholder: "Enter Description",
      validate: [
        {
          rule: (value: any) => !!value,
          message: "Description is required",
        },
      ],
      description:
        "Provide a comprehensive description outlining the purpose and scope of the terms and conditions.",
    },
  ];
  const [isShows, setIsShows] = useState<boolean>(false);
  const [dynamicFormFields, setDynamicFormFields] = useState([]);

  const handleHelpButtonClick = () => {
    setIsShows(!isShows);
    const formBottom = document.getElementById("form-bottom");
    if (formBottom) {
      formBottom.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    DynamicFormFields(formFields, "terms_and_conditions").then(
      (updatedFormFields) => {
        setDynamicFormFields(updatedFormFields);
      },
    );
  }, []); // eslint-disable-line

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        <Breadcrumb.Item href="/terms-and-conditions">
          Terms & Conditions
        </Breadcrumb.Item>
        <Breadcrumb.Item active className="fw-bold">
          {!id ? "Add Terms & Conditions" : "Edit Terms & Conditions"}
        </Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <span style={{ float: "inline-end" }}>
          <Button variant="outline-secondary" onClick={handleHelpButtonClick}>
            Need Help?
          </Button>
        </span>
        <AddUpdateForm
          formFields={dynamicFormFields}
          model={TermsAndCondition}
          title={title}
          listRoute={listRoute}
          entityName={"terms-and-conditions"}
          entityType={"terms_and_conditions"}
          isDynamicFormFields={true}
          isNotUpdate={isNotUpdate}
          onChangeModalStatus={onChangeModalStatus}
        />
      </div>
      <div id="form-bottom">
        <FieldDescription
          title={title}
          formFields={dynamicFormFields}
          isShows={isShows}
        />
      </div>
    </>
  );
};

export default AddUpdate;
